import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import InputItem from '../InputItem';
import Flex from '../../atoms/Flex';
import IconButton from '../../atoms/IconButton';
import Delete from '../../atoms/icons/Delete';
import styled from 'styled-components';
import { color } from '../../templates/Ui';
import Plus from '../../atoms/icons/Plus';
import Button from '../../atoms/Button';
import MoneyInputItem from '../MoneyInputItem';
export const StyledDelete = styled(Delete) `
    transition: fill 0.2s ease-in-out;
    margin-top: 4px;
    fill: ${color.error.base};
`;
export const StyledButton = styled(Button) `
    position: relative;
    display: inline-block;
    font-weight: 600;
    color: ${props => props.theme.secondary};
    margin-top: 20px;
    text-decoration: none;
    padding: 0 0 4px 0;
    max-width: 140px;

    &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: ${props => props.theme.secondary};
        transition: all 200ms ease-in-out;
        border-radius: 1px;

        @media only screen and (min-width: 992px) {
            width: 0;
        }
    }

    &:hover {
        @media only screen and (min-width: 992px) {
            &:before {
                width: 100%;
            }
        }
    }
`;
export const StyledIconButton = styled(IconButton) `
    transition: all 0.2s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    fill: ${color.error.base};
    border-radius: 50%;
    padding: 0;
    width: 40px;
    height: 40px;
    background-color: transparent;

    .button__content {
        display: block;
    }

    &:hover {
        background-color: ${color.error.base};

        svg {
            fill: ${color.body.base};
        }
    }
`;
export const StyledPlus = styled(Plus) `
    fill: ${props => props.theme.secondary};
    margin-right: 4px;
`;
const StyledInputItem = styled(InputItem) `
    margin-bottom: 0;
`;
const StyledMoneyInput = styled(MoneyInputItem) `
    margin-bottom: 0;
`;
const Invoices = forwardRef(({ data, errors, setData }, ref) => {
    const initialRow = {
        date: '',
        number: '',
        amount: '',
        description: '',
    };
    const [invoices, setInvoices] = useState(data?.invoices?.length ? data.invoices : [initialRow]);
    useEffect(() => setData('invoices', invoices), [invoices]);
    const handleChange = (index, e) => {
        const data = [...invoices];
        data[index] = {
            ...data[index],
            [e.currentTarget.name]: e.currentTarget.value,
        };
        setInvoices(data);
    };
    const removeRow = (index) => {
        const data = [...invoices];
        data.splice(index, 1);
        setInvoices(data);
    };
    const reset = () => setInvoices([initialRow]);
    useImperativeHandle(ref, () => ({ reset }));
    return (_jsxs(_Fragment, { children: [invoices.map((invoice, index) => {
                return (_jsxs(Flex, { margin: "0 0 20px 0", fullWidth: true, alignItems: "center", children: [_jsx(StyledInputItem, { label: "Datum", placeholder: "", type: "date", size: "small", name: "date", min: "2000-01-01", max: "2100-01-01", value: invoice.date, error: errors ? errors[`invoices.${index}.date`] : '', required: index === 0, onChange: e => handleChange(index, e) }), _jsx(StyledInputItem, { label: "Factuurnummer", placeholder: "Bijv. 2021-0001", type: "text", size: "small", name: "number", value: invoice.number, error: errors ? errors[`invoices.${index}.number`] : '', required: index === 0, onChange: e => handleChange(index, e) }), _jsx(StyledMoneyInput, { label: "Bedrag", placeholder: "Bijv. \u20AC 10,50", type: "number", size: "small", name: "amount", min: -999999, max: 999999, value: invoice.amount, error: errors ? errors[`invoices.${index}.amount`] : '', step: 0.01, required: index === 0, onChange: e => handleChange(index, e) }), _jsx(StyledInputItem, { label: "Omschrijving", placeholder: "Bijv. de verrichte diensten of een product.", type: "text", name: "description", value: invoice.description, error: errors
                                ? errors[`invoices.${index}.description`]
                                : '', onChange: e => handleChange(index, e) }), index > 0 && (_jsx(StyledIconButton, { "aria-label": 'Verwijder factuurregel', type: "button", onClick: () => removeRow(index), children: _jsx(StyledDelete, {}) }))] }, 'invoice-' + index));
            }), _jsxs(StyledButton, { type: "button", transparent: true, onClick: () => setInvoices(prevState => [...prevState, initialRow]), children: [_jsx(StyledPlus, {}), "Extra factuur"] })] }));
});
export default Invoices;
